function _extends() {
  _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React, {forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState} from "react";
import ChromePicker from "../../../../__snowpack__/pkg/react-color/lib/components/chrome/Chrome.js";
import {cmpClassName, execFn} from "../../../common/generic-react.functions.js";
import {useEventListener} from "../../../hooks/event-listener.hook.js";
import Input from "../../atoms/input/input.component.js";
import {useValidationInput} from "../../atoms/input/input.hooks.js";
import {ChromePickerContainer, ColorPickerContainer, ColorPickerSampleContainer} from "./color-picker.styles.js";
function MainColorPicker({
  value,
  disabled,
  readOnly,
  onFocus,
  onBlur,
  onChange,
  onChangeComplete,
  size = "base",
  rules,
  ...inputOptions
}, ref) {
  const [color, setColor] = useState(value);
  const [showPicker, setShowPicker] = useState(false);
  const wrapperRef = useRef(null);
  const inputRef = useRef(null);
  const {
    errorMessage: [errorMessage]
  } = useValidationInput({
    inputRef: inputRef.current?.el,
    rules
  });
  useImperativeHandle(ref, () => {
    return {
      ...inputRef.current,
      el: inputRef.current?.el || null,
      value: color?.toUpperCase()
    };
  }, [color]);
  useEffect(() => {
    setColor(value);
  }, [value]);
  useEventListener("click", ({
    target
  }) => {
    if (wrapperRef.current?.contains && !wrapperRef.current.contains(target)) {
      _onBlur();
    }
  });
  const _onChange = useCallback((result) => {
    const colorResult = result.hex;
    setColor(colorResult);
    execFn(onChange, colorResult);
  }, [onChange]);
  const _onChangeComplete = useCallback((result) => {
    const colorResult = result.hex;
    setColor(colorResult);
    execFn(onChangeComplete, colorResult);
  }, [onChangeComplete]);
  const _onFocus = useCallback(() => {
    if (disabled || readOnly) {
      return;
    }
    setShowPicker(true);
    execFn(onFocus, color || void 0);
  }, [color, disabled, onFocus, readOnly]);
  const _onBlur = useCallback(() => {
    if (disabled || readOnly) {
      return;
    }
    setShowPicker(false);
    execFn(onBlur, color || void 0);
  }, [color, disabled, onBlur, readOnly]);
  return /* @__PURE__ */ React.createElement(ColorPickerContainer, {
    ref: wrapperRef,
    className: cmpClassName("color-picker"),
    role: "color-picker",
    reset: inputOptions.reset,
    size
  }, /* @__PURE__ */ React.createElement(Input, _extends({}, inputOptions, {
    ref: inputRef,
    size,
    value: color?.toUpperCase(),
    onFocus: _onFocus,
    readOnly: true,
    disabled,
    append: /* @__PURE__ */ React.createElement(ColorPickerSampleContainer, {
      color: color || void 0,
      size
    })
  })), showPicker && /* @__PURE__ */ React.createElement(ChromePickerContainer, {
    role: "color-picker-selector"
  }, /* @__PURE__ */ React.createElement(ChromePicker, {
    color: color || void 0,
    onChange: _onChange,
    onChangeComplete: _onChangeComplete
  })), errorMessage && /* @__PURE__ */ React.createElement("div", {
    className: "input__error"
  }, errorMessage));
}
const ColorPicker = /* @__PURE__ */ React.memo(/* @__PURE__ */ forwardRef(MainColorPicker));
ColorPicker.displayName = "ColorPicker";
export default ColorPicker;
